import type { ProjectSummary } from "../types";
import { renderPagePath } from "../view-helpers";

export function renderProjectRecordPreviewPage(project: ProjectSummary): string {
  return `
    <section class="screen">
      <header class="topbar">
        <button class="ghost-button" data-action="back-to-preview-home">返回成品预览与发送</button>
        <h1>记录表成品预览</h1>
      </header>
      ${renderPagePath([
        { label: project.name, href: `#/projects/home?id=${project.id}` },
        { label: "成品预览与发送", href: `#/projects/preview?id=${project.id}` },
        { label: "记录表成品预览" },
      ])}
      <div class="panel stack">
        <p class="muted">这里直接渲染刚刚生成出来的记录表 Word，用来检查表格排版、勾选位置和每一行对应关系。不是文本列表，而是成品预览。</p>
        <div class="inline-pills">
          <span class="state-pill" id="generated-preview-status">准备生成记录表成品预览...</span>
        </div>
        <button class="ghost-button" type="button" data-action="refresh-generated-preview">重新生成当前成品预览</button>
      </div>
      <section class="panel stack">
        <div id="generated-docx-preview" class="generated-docx-preview" aria-live="polite"></div>
      </section>
    </section>
  `;
}
